import { HttpFailedRequestError } from "@core/domain/infrastructures/http/errors/http-failed-request.error";

export class HttpTooManyRequestsError<
    T = unknown,
> extends HttpFailedRequestError<T> {
    static readonly CODE = 429;

    constructor(data?: T) {
        super(HttpTooManyRequestsError.CODE, undefined, undefined, data);

        Object.setPrototypeOf(this, HttpTooManyRequestsError.prototype);
    }
}
